// extracted by css-extract-rspack-plugin
export default {"search_form_input":"qI58j","searchFormInput":"qI58j","icon":"I5HmZ","input":"LYAZs","short":"Fgknf"};